<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="completShipment" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalCompleteShipmentVisible" :vm-title="$t('shipments.complete_title')")
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: completShipment, push: true, focus: true, disabled: $v.form.$invalid },]")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-textarea(autofocus :placeholder='$t("shipments.completed_comment_placeholder")' :danger="$v.form.completed_comment.$invalid && $v.form.completed_comment.$model" :danger-text="$t('validation.required', { attribute: $t('shipments.completed_comment') })" v-model="form.completed_comment" :label='$t("shipments.completed_comment")')
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Shipments')

export default {
  name: 'ModalCompleteShipment',
  mixins: [ModalMixin1],
  data: () => ({
    isWeb: true
  }),
  validations () {
    return {
      form: {
        completed_comment: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalCompleteShipmentVisible'])
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'setModalCompleteShipmentVisible',
      'actionRecord'
    ]),
    completShipment () {
      this.form.id && this.actionRecord({ id: this.form.id, action: 'complete', completed_comment: this.form.completed_comment, is_web: this.isWeb })
      this.setModalCompleteShipmentVisible(false)
    },
    close () {
      this.setModalCompleteShipmentVisible(false)
    }
  }
}
</script>
